export const games = {
    "yx": "遊戲",
    "yxms": "在加密遊戲中，所有決定競賽結果的決策都提前以哈希形式生成，遊戲結果不會受到任何人意志的改變，確保絕對的公平公正！",
    "mnsm": "模擬試玩",
    "ljqw": "立即去玩",
    loading: '載入中，請稍候',
    dyh: '多樣化選擇權合約供您選擇，百倍收益，短期超高投資報酬率',
    qyhy:'選擇權合約',
    qsyhys:'選擇權',
    kd:'開單',
    qt:'趣投',
    ljjy: "立即交易",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/tw.js